import React from "react";
import cx from "classnames";
import { host } from "../nav-util/url";
var www = host.www,
  auto = host.auto;
var NavServiceText = function NavServiceText(_ref) {
  var id = _ref.id,
    title = _ref.title,
    href = _ref.href,
    onClick = _ref.onClick,
    active = _ref.active,
    navActive = _ref.navActive,
    _ref$isShow = _ref.isShow,
    isShow = _ref$isShow === void 0 ? true : _ref$isShow,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$innerClassName = _ref.innerClassName,
    innerClassName = _ref$innerClassName === void 0 ? "" : _ref$innerClassName;
  return isShow ? /*#__PURE__*/React.createElement("div", {
    id: id,
    style: style,
    className: cx("tc-top-nav-item", {
      active: active === navActive
    })
  }, /*#__PURE__*/React.createElement("a", {
    className: cx("tc-top-nav-link", "".concat(innerClassName)),
    href: href,
    onClick: onClick,
    target: '_blank',
    rel: 'noreferrer'
  }, title, /*#__PURE__*/React.createElement("div", {
    className: "nav-popover"
  }, /*#__PURE__*/React.createElement("a", {
    className: "nav-popover-link",
    href: "".concat(www, "/rating-index.html")
  }, "\u4FE1\u7528\u8A55\u50F9"), /*#__PURE__*/React.createElement("a", {
    className: "nav-popover-link",
    href: "".concat(www, "/checkCar-info.html")
  }, "\u67E5\u8ECA\u6A5F\u5236"), /*#__PURE__*/React.createElement("a", {
    className: "nav-popover-link",
    href: "".concat(auto, "/usedauto-queryRange.html")
  }, "\u91CC\u7A0B\u67E5\u8A62")))) : null;
};
export default NavServiceText;